import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import Toggle from 'react-toggle';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import Helmet from 'react-helmet';

import { fetchRegistry } from '../../../actions/RegistryActions';
import { fetchGuestList } from '../../../actions/GuestActions';
import { showModal } from '../../../actions/ModalActions';
import fetchModuleGroup from '../../../actions/ModuleGroupActions';
import { togglePage, fetchPages } from '../../../actions/website/PageActions';
import { updateWeddingAccount, toggleWebsite } from '../../../actions/WeddingActions';
import NavItem from '../../common/ui/NavItem';
import WebsiteSlug from './entities/WebsiteSlug';
import { ManageWebsiteActions, ManageWebsiteActionsV2 } from './entities/ManageWebsiteActions';
import WebsiteNav from '../../../components/common/header/SecondaryNav/SecondaryNav';
import { manageNavItems, weddingWebsiteNavItems } from '../../../components/common/header/SecondaryNav/secondaryNavData';
import '../../../stylesheets/pages/EditPage.less';


class ManagePages extends Component {
  constructor(props) {
    super(props);
    this.handlePasscodeToggle = this.handlePasscodeToggle.bind(this);
    this.toggleWebsitePublish = this.toggleWebsitePublish.bind(this);
    this.state = {
      copyCta: 'Copy Link',
      copyLinkDisabled: false,
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported()
    };
  }

  componentDidMount() {
    const {
      pages,
      hasRegistry,
      getPages,
      getRegistry,
      getGuestList,
      getModules,
      registry
    } = this.props;

    if (pages.orderedIds.length === 0) {
      getPages();
    }

    // if registry status doesn't exist, that means registry info has not been fetched yet
    if (hasRegistry && !registry.status) {
      getRegistry();
    }

    getGuestList();
    getModules();

    this.initializeClipboard();

    if (window.zolaNav) {
      window.zolaNav.setTopLinkActive();
    }
  }

  componentWillUnMount() {
    this.destroyClipboard();
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#website-slug__copy-text');

    clipboard.on('success', () => {
      this.setState({
        copyCta: 'Copied!',
        copyLinkDisabled: true
      });
      setTimeout(() => {
        this.setState({
          copyCta: 'Copy Link',
          copyLinkDisabled: false
        });
      }, 1500);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  handlePasscodeToggle() {
    const { account, onEnablePasscode, onDisablePasscode } = this.props;
    if (account.enable_passcode) {
      onDisablePasscode(account);
    } else {
      onEnablePasscode();
    }
  }

  toggleWebsitePublish() {
    const { onTogglePublish, openHidePagesModal, account } = this.props;
    if (account.published) {
      onTogglePublish(false);
    } else {
      openHidePagesModal();
    }
  }

  render() {
    const {
      wedding,
      account,
      pages,
      moduleGroup,
      openReorderPagesModal,
      openWebsiteSettingsModal,
      slug,
      openShare,
      shareInfo,
      openDomainModal,
      pageKey,
      publishWebsite,
      published,
      themeGroupTitle
    } = this.props;

    const {
      copyCta,
      copyLinkDisabled,
      isClipboardSupported
    } = this.state;

    const toolTip = 'If you want to edit your Zola website address, give us a call at 1-408-657-ZOLA or email support@zola.com.';
    const longSlugName = slug && slug.length > 20;

    return (
      <div>
        <Helmet>
          <title>Zola Weddings</title>
        </Helmet>
        {
          window.zola.feature.newUnifiedNav ?
            <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive={false} /></span> :
            <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={manageNavItems} altActive={false} /></span>
        }
        <span className="hidden-md hidden-lg"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive={false} /></span>
        <div
          className={classNames(
            'manage-website-v2',
            { 'manage-website__container': window.zola.feature.removeWebsiteSettings }
          )}
        >
          <div>
            <div className="row">
              <h1 className="page-heading col-sm-6">Manage Website</h1>
              {!window.zola.feature.removeWebsiteSettings && slug && (
                <ul className="nav navbar-nav navbar-right visible-xs">
                  <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
                    <button type="button" className="btn btn-primary navbar-btn" >Preview Website</button>
                  </NavItem>
                  <NavItem to="" activeClassName="active">
                    <button type="button" className="btn btn-secondary navbar-btn" onClick={() => openShare(Object.assign({}, shareInfo, { slug }))}>Share Website</button>
                  </NavItem>
                </ul>
              )}
              {!window.zola.feature.removeWebsiteSettings && slug && published && (
                <ul className="nav navbar-nav navbar-right hidden-xs">
                  <NavItem to="" activeClassName="active">
                    <button type="button" className="btn btn-primary navbar-btn visible" onClick={() => openShare(Object.assign({}, shareInfo, { slug }))}>Share Website</button>
                  </NavItem>
                  <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
                    <button type="button" className="btn btn-secondary navbar-btn view" >View Website</button>
                  </NavItem>
                </ul>
              )}
              {!window.zola.feature.removeWebsiteSettings && slug && !published && (
                <ul className="nav navbar-nav navbar-right hidden-xs">
                  <NavItem to="" activeClassName="active">
                    <button type="button" className="btn btn-primary navbar-btn make-website-visible" onClick={() => publishWebsite(published)}>Make Website Visible</button>
                  </NavItem>
                  <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
                    <button type="button" className="btn btn-secondary navbar-btn">Preview Website</button>
                  </NavItem>
                </ul>
              )}
              {
                (window.zola.feature.removeWebsiteSettings && window.zola.env === 'development') &&
                  <ManageWebsiteActionsV2
                    slug={slug}
                    published={published}
                    pageKey={pageKey}
                    publishWebsite={this.toggleWebsitePublish}
                  />
              }
              {
                (window.zola.feature.removeWebsiteSettings && window.zola.env !== 'development') &&
                  <ManageWebsiteActions
                    slug={slug}
                    published={published}
                    pageKey={pageKey}
                    publishWebsite={this.toggleWebsitePublish}
                  />
              }
            </div>
            {
              window.zola.feature.removeWebsiteSettings &&
                <WebsiteSlug
                  longSlugName={longSlugName}
                  slug={slug}
                  published={published}
                  copySlug={this.copySlug}
                  copyCta={copyCta}
                  copyLinkDisabled={copyLinkDisabled}
                  isClipboardSupported={isClipboardSupported}
                />
            }
            {
              !window.zola.feature.removeWebsiteSettings &&
                <div className="manage-section">
                  <div className="manage-panel website-details">
                    <div className="row">
                      <div className="col-xs-12 col-md-5 manage-panel-header website-overview">
                        <div className="title">
                          <span className="">Website Address</span>
                        </div>
                        <div className="body">
                          <div className="website-address">
                            {`${window.location.host}`}/wedding/<b className="no-tooltip-on-mobile" data-tooltip={toolTip} data-placement="right">{wedding.slug}</b>
                          </div>
                          <p className="website-help-msg">
                            <span className="body-copy">Want to change your website address? </span>
                            <a onClick={openDomainModal}>Find out how &rsaquo;
                          </a></p>
                        </div>
                      </div>
                      <div className="hidden-xs hidden-sm col-md-7 manage-website-actions">
                        <div className="row website-info">
                          <div className="padding-bottom website-info-row">
                            <div className="toggle">
                              <div className="with-tooltip" data-tooltip="Ready to show off your website? Switch the toggle to &quot;Yes&quot; and anyone will be able to see it. Not ready yet? Keep the toggle on &quot;No.&quot;">
                                <span className="title website-info-label toggle-title">Website Visible?</span>
                                <div className="toggle-button-inline">
                                  <Toggle
                                    checked={account.published}
                                    onChange={this.toggleWebsitePublish}
                                    className="toggle-small toggle-red"
                                    icons={{ checked: <span className="toggle-label checked visible-no">Yes</span>, unchecked: <span className="toggle-label unchecked visible-yes">No</span> }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row website-info">
                          <div className="padding-bottom website-info-row">
                            <div className="toggle">
                              <div className="with-tooltip" data-tooltip="Want to make your website visible to guests, but not the general public? Enable this feature, then only people with the password can see your website.">
                                <span className="title website-info-label toggle-title">Password Protected?</span>
                                <div className="toggle-button-inline">
                                  <Toggle
                                    checked={account.enable_passcode}
                                    onChange={this.handlePasscodeToggle}
                                    className="toggle-small"
                                    icons={{ checked: <span className="toggle-label checked password-no">Yes</span>, unchecked: <span className="toggle-label unchecked password-yes">No</span> }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <span className="edit-settings-button">
                            <button className="btn btn-primary" onClick={openWebsiteSettingsModal}>Edit Settings</button>
                          </span>
                        </div>
                        <div className="row website-info">
                          <div className="website-info-row">
                            <div className="title website-info-label">Selected Design</div>
                            <div className="website-info-link">
                              <Link to="/wedding/manage/website/designs">{themeGroupTitle}</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            }
            {
              !window.zola.feature.removeWebsiteSettings &&
              <div className="manage-section visible-xs visible-sm">
                <div className="manage-panel website-details">
                  <div className="manage-website-actions">
                    <div className="website-info">
                      <div className="padding-bottom website-info-row">
                        <div className="toggle">
                          <span className="title website-info-label toggle-title">Website Visible?</span>
                          <div className="toggle-button-inline">
                            <Toggle
                              checked={account.published}
                              onChange={this.toggleWebsitePublish}
                              className="toggle-small toggle-red"
                              icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="website-info">
                      <div className="padding-bottom website-info-row">
                        <div className="toggle">
                          <span className="title website-info-label toggle-title">Password Protected?</span>
                          <div className="toggle-button-inline">
                            <Toggle
                              checked={account.enable_passcode}
                              onChange={this.handlePasscodeToggle}
                              className="toggle-small"
                              icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                            />
                          </div>
                        </div>
                      </div>
                      <span className="edit-settings-button hidden-xs">
                        <button className="btn btn-primary" onClick={openWebsiteSettingsModal}>Edit Settings</button>
                      </span>
                    </div>
                    <div className="website-info">
                      <div className="padding-bottom website-info-row">
                        <div className="title website-info-label">Selected Design</div>
                        <div className="website-info-link">
                          <Link to="/wedding/manage/website/designs">{themeGroupTitle}</Link>
                        </div>
                      </div>
                    </div>
                    <div className="website-info visible-xs">
                      <div className="website-info-row">
                        <div className="title website-info-label">
                          <button className="btn btn-primary" onClick={openWebsiteSettingsModal}>Edit Settings</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div className="manage-section">
              <div className="manage-panel website-pages">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="manage-panel-header">
                      <div className="title">
                        <span className="manage-website-label">Website Pages</span>
                      </div>
                      <div className="body">
                        <p>
                          Click on any of the pages below to edit it. Want to switch around the order of your pages?
                          <a role="button" onClick={openReorderPagesModal} className="text-button">Reorder Pages &rsaquo;</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 manage-panel-content">
                    <div className="pages">
                      <div className="row">
                        {pages.orderedIds.map(id => (
                          <div key={id} className={`col-xs-4 col-sm-3 col-lg-2 page ${pages.byId[id].type.toLowerCase()}`}>
                            <Link to={`/wedding/manage/website/pages/${pages.byId[id].type.toLowerCase()}`} className={`${pages.byId[id].type.toLowerCase()} manage-page-module-link`}>
                              <i className={`zolaicon zolaicon-${pages.byId[id].type.toLowerCase()}`} />
                              <div className="page-title">{pages.byId[id].menu_title}</div>
                              <div className="text-muted" style={{ visibility: pages.byId[id].hidden ? '' : 'hidden' }}>
                                <em>(Hidden)</em>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="website-modules">
              {moduleGroup.moduleViews && (
                <div id="weddings-manage-pages-marketing-modules" className="row">
                  {moduleGroup.moduleViews.map((moduleView, idx) => (
                    <div className="col-xs-12 col-md-6 marketing-module" key={idx}>
                      <a href={moduleView.link_path} rel="noopener noreferrer">
                        <img src={moduleView.images_by_dimension['590x300']} alt={moduleView.title} className="img-responsive" />
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ManagePages.propTypes = {
  wedding: PropTypes.shape({}),
  account: PropTypes.shape({}),
  hasRegistry: PropTypes.bool,
  pages: PropTypes.shape({}),
  moduleGroup: PropTypes.shape({}),
  getRegistry: PropTypes.func,
  getGuestList: PropTypes.func,
  getPages: PropTypes.func,
  getModules: PropTypes.func,
  onTogglePublish: PropTypes.func,
  onEnablePasscode: PropTypes.func,
  onDisablePasscode: PropTypes.func,
  openReorderPagesModal: PropTypes.func,
  openWebsiteSettingsModal: PropTypes.func,
  openHidePagesModal: PropTypes.func,
  slug: PropTypes.string,
  published: PropTypes.bool,
  shareInfo: PropTypes.shape({}),
  openShare: PropTypes.func,
  openDomainModal: PropTypes.func,
  pageKey: PropTypes.string,
  publishWebsite: PropTypes.func.isRequired,
  themeGroupTitle: PropTypes.string,
  registry: PropTypes.shape({})
};

const mapStateToProps = state => ({
  wedding: state.wedding.wedding,
  account: state.wedding.account,
  hasRegistry: state.user.userContext.has_registry,
  registry: state.registry,
  theme: state.wedding.theme,
  guestGroups: state.guestList.guests.byId,
  pages: state.website.pages,
  moduleGroup: state.moduleGroup['weddings-manage-pages'] || {},
  slug: state.wedding.wedding.slug,
  published: state.wedding.account.published,
  themeGroupTitle: state.wedding.themeGroupTitle,
});

const mapDispatchToProps = dispatch => ({
  getRegistry: () => dispatch(fetchRegistry()),
  getModules: () => dispatch(fetchModuleGroup('weddings-manage-pages')),
  getGuestList: () => dispatch(fetchGuestList()),
  getPages: () => dispatch(fetchPages()),
  onTogglePublish: publish => dispatch(toggleWebsite(publish)),
  openHidePagesModal: () => dispatch(showModal('HIDE_PAGES', {}, { size: 'md' })),
  onEnablePasscode: () => dispatch(showModal('WEBSITE_SETTINGS', { enablePasscode: true }, { size: 'md' })),
  onDisablePasscode: (account) => {
    const accountRequest = Object.assign({}, account, { enable_passcode: false, passcode: undefined, passcode_instructions: undefined });
    return dispatch(updateWeddingAccount(accountRequest));
  },
  onTogglePage: id => dispatch(togglePage(id)),
  showErrorModalv2: () => dispatch(showModal('PUBLISH_PAGE_ERROR', {
    heading: 'Want guests to RSVP on your wedding website?',
    body: 'First, create an event and build a guest list for it. Then you\'ll be able to unhide this page and let guests RSVP on this page',
    button: {
      text: 'Create An Event',
      action: () => browserHistory.push('/wedding/manage/events')
    } }, { size: 'md' })),
  showSuccessModal: () => dispatch(showModal('PUBLISH_RSVP', {}, { size: 'md' })),
  openReorderPagesModal: () => dispatch(showModal('REORDER_PAGES', {}, { size: 'md' })),
  openWebsiteSettingsModal: () => dispatch(showModal('WEBSITE_SETTINGS', {}, { size: 'md' })),
  openShare: (wedding) => {
    dispatch(showModal('SHARE', { wedding }, { size: 'md' }));
  },
  publishWebsite: (published) => {
    if (published) {
      dispatch(toggleWebsite(false));
    } else {
      dispatch(showModal('HIDE_PAGES', {}, { size: 'md' }));
    }
  },
  openDomainModal: () => dispatch(showModal('CUSTOM_DOMAIN_MODAL', {}, { size: 'md' })),
  openDomainCompltionModal: () => dispatch(showModal('CUSTOM_DOMAIN_COMPLETION_MODAL', {}, { size: 'md' }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagePages);



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/ManagePages.jsx
 **/